import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useRouteMatch, useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import PageHeader from '../common/PageHeader';
import SelectField from '../common/SelectField';
import InputField from '../common/InputField';
import Button from '../common/Button';
import Alert from '../common/Alert';
import Snackbar from '../common/Snackbar';

import { parseRequestError } from '../../utils/errors';
import * as apiClient from '../../apiClient';

function BusCall() {
  const { path } = useRouteMatch();
  const history = useHistory();
  const [files, setFiles] = useState([]);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);

  const redirectToHome = () => {
    history.push(`/${path.split('/')[1]}`);
  };

  useEffect(() => {
    const loadFiles = async () => {
      const response = await apiClient.getBusFiles();
      setFiles(response.items);
    };

    loadFiles();
  }, []);

  const handleSubmit = async (values, { setErrors, resetForm }) => {
    setSubmitError(null);

    try {
      await apiClient.realtimeBusCall(values);
      setSubmitSuccess('Chamada enviada com sucesso.');
      resetForm();
      redirectToHome();
    } catch (error) {
      const [errorMessage, errorDetails] = parseRequestError(error);
      if (errorDetails) {
        setErrors(errorDetails);
      } else {
        setSubmitError(errorMessage);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setSubmitSuccess(null);
  };

  const companyFileOptions = [];
  const originFileOptions = [];
  const destinationFileOptions = [];
  const timeFileOptions = [];
  const messageFileOptions = [];
  files.forEach((file) => {
    if (file.type === 'BUS_COMPANY') {
      companyFileOptions.push({ value: file.file, label: file.fileName });
    }
    if (file.type === 'BUS_ORIGIN') {
      originFileOptions.push({ value: file.file, label: file.fileName });
    }
    if (file.type === 'BUS_DESTINATION') {
      destinationFileOptions.push({ value: file.file, label: file.fileName });
    }
    if (file.type === 'BUS_TIME') {
      timeFileOptions.push({ value: file.file, label: file.fileName });
    }
    if (file.type === 'BUS_MESSAGE') {
      messageFileOptions.push({ value: file.file, label: file.fileName });
    }
  });

  return (
    <div>
      <PageHeader title="Aviso de Ônibus" />
      <div className="p-6">
        <Snackbar open={Boolean(submitSuccess)} onClose={handleCloseSnackbar}>
          <Alert type="success" className="shadow-md">
            {submitSuccess}
          </Alert>
        </Snackbar>
        <div className="max-w-2xl mx-auto">
          <Formik
            initialValues={{
              company: '',
              origin: '',
              destination: '',
              time: '',
              number: '',
              message: '',
            }}
            validationSchema={Yup.object({
              company: Yup.string().required('Campo obrigatório.'),
              origin: Yup.string().required('Campo obrigatório.'),
              destination: Yup.string().required('Campo obrigatório.'),
              time: Yup.string(),
              number: Yup.string(),
              message: Yup.string().required('Campo obrigatório.'),
            })}
            onSubmit={handleSubmit}
          >
            <Form noValidate autoComplete="off">
              <SelectField name="company">
                <option value="">Empresa</option>
                {companyFileOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <SelectField name="origin">
                <option value="">Origem</option>
                {originFileOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <SelectField name="destination">
                <option value="">Destino</option>
                {destinationFileOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <SelectField name="time">
                <option value="">Horário</option>
                {timeFileOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <InputField
                name="number"
                placeholder="Número do ônibus"
                mask="999999"
              />
              <SelectField name="message">
                <option value="">Mensagem</option>
                {messageFileOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </SelectField>
              <div className="flex items-center justify-end mb-5">
                <Button type="submit" color="primary">
                  Chamar
                </Button>
              </div>
              <div className="mb-5">
                {submitError ? <Alert type="error">{submitError}</Alert> : null}
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default BusCall;
